import { Routes, Route, useLocation } from "react-router-dom";
import { AuthProvider } from "./context/AuthContext";
import { ProductProvider } from "./context/ProductContext";
import { CartProvider } from "./context/CartContext";
import { AddressProvider } from "./context/AddressContext";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import AuthGate from "./pages/AuthGate";
import Navbar from "./components/Navbar";
import Footer from "./pages/Footer";

import FrontPage from "./components/FrontPage";
import ProductPage from "./pages/ProductPage";
import ProductDetails from "./pages/ProductDetails";
import Men from "./pages/Men";
import Women from "./pages/Women";
import Kids from "./pages/Kids";
import Electronics from "./pages/Electronics";
import CartPage from "./pages/CartPage";
import Wishlist from "./pages/Wishlist";
import CheckoutPage from "./pages/CheckoutPage";
import OrderSuccessPage from "./pages/OrderSuccessPage";
import AddressPage from "./pages/AddressPage";
import ProfilePage from "./pages/ProfilePage";
import Login from "./pages/Login";
import Register from "./pages/Register";

function AppLayout() {
  const location = useLocation();
  const hideChrome = ["/login", "/register"].includes(location.pathname);

  return (
    <AuthGate>
      {!hideChrome && <Navbar />}

      <main>
        <Routes>
          <Route path="/" element={<FrontPage />} />
          <Route path="/product" element={<ProductPage />} />
          <Route path="/men" element={<Men />} />
          <Route path="/women" element={<Women />} />
          <Route path="/kids" element={<Kids />} />
          <Route path="/electronics" element={<Electronics />} />
          <Route path="/detail/:id" element={<ProductDetails />} />
          <Route path="/cart" element={<CartPage />} />
          <Route path="/wishlist" element={<Wishlist />} />
          <Route path="/checkout" element={<CheckoutPage />} />
          <Route path="/order-success" element={<OrderSuccessPage />} />
          <Route path="/address" element={<AddressPage />} />
          <Route path="/profile" element={<ProfilePage />} />
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
        </Routes>
      </main>

      {!hideChrome && <Footer />}
    </AuthGate>
  );
}

function App() {
  return (
    <AuthProvider>
      <ProductProvider>
        <CartProvider>
          <AddressProvider>
            <AppLayout />
            <ToastContainer
              position="top-right"
              autoClose={2000}
              pauseOnHover
              theme="light"
            />
          </AddressProvider>
        </CartProvider>
      </ProductProvider>
    </AuthProvider>
  );
}

export default App;